import { forwardRef } from "react";
function SvgRawChevronDownIcon(
  { title, titleId, strokeWidth = 2, ...props },
  ref,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="none"
        stroke="#000"
        strokeWidth={strokeWidth}
        d="m4 8 8 8 8-8"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawChevronDownIcon);
export default ForwardRef;
